import { IconButton, InputAdornment, TextField } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";

interface SearchInputProps {
  dataQa: string;
  value: string;
  onChange: (searchText: string) => void;
  onClear: () => void;
}

export const SearchInput = ({
  dataQa,
  value,
  onChange,
  onClear
}: SearchInputProps): JSX.Element => {
  return (
    <TextField
      data-qa={dataQa}
      variant="outlined"
      placeholder="Search"
      size="small"
      value={value}
      onChange={ev => onChange(ev.target.value)}
      inputProps={{ maxLength: 150 }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {value ? (
              <IconButton disabled={!value} onClick={onClear} size="large">
                <ClearIcon />
              </IconButton>
            ) : (
              <StyledSearchIcon />
            )}
          </InputAdornment>
        )
      }}
    />
  );
};

const StyledSearchIcon = styled(SearchIcon)`
  color: #ddd;
`;
